/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
  GetProductDetails,
  GetProductDetailsByProductID,
  SaveProduct,
  UpdateProduct,
  GetProductCategoties,
  GetProductTypes,
  SaveFarmer,
  GetProvinceForDropdown,
  GetDistrictForDropdown,
  GetCityForDropdown,
  GetAllFarmers,
  GetFarmerByFarmerID,
  GetFarmeCroprByFarmerID,
  UpdateFarmer,
  DeleteFarmerCrop,
  GetAllGroupsForDropDown,
  GetAllFactoriesByGroupID,
  GetRouteByFactoryID,
  GetProductLifeCyclePikingDetailsByProductID,
  GetRouteByGroupID,
  GetFarmerCollectionCenterDetailsByFarmerID,
  DeleteFarmerCollectionCenterDetails,
  GetFarmersByGroupIDAndOperationEntityID,
  GetFarmerDetailsByNIC,
  AssignFarmer,
  GetBanksForDropdown,
  GetBranchForDropdown,
  SaveFarmerBankDetails,
  GetBankDetailsbyFarmerID,
  DeleteFarmerBankDetails,
  GetLoanTypeDetails,
  SaveFarmerLoanDetails,
  GetAllLoanDetailsbyFarmerID,
  DeleteLoanDetails,
  SaveFarmerScholarshipDetails,
  GetFarmerScholarshipDetailsbyFarmerID,
  GetFarmerFamilyDetailsbyFarmerID,
  DeleteScholarshipDetails,
  SaveFarmerFamilyDetail,
  DeleteFarmerFamilyDetil,
  GetFarmerFamilyByFarmerID,
  SaveFarmingDetails,
  GetFarmingDetailsbyFarmerID,
  DeleteFarmingDetails,
  UpdateFarmerFamilyDetail,
  UpdateFarmerBankDetails,
  UpdateFarmerLoanDetails,
  UpdateFarmerScholarshipDetails,
  UpdateFarmingDetails,
  GetAllFarmerDocumentByFarmerID,
  DeleteFarmerDocument,
  SaveFarmerDocumentInUpdate,
  SaveVehicleData,
  SaveIncomeData,
  GetIncomeandVehicleData,
  DeleteFarmerIncomeDetails,
  DeleteFarmerVehicleDetails,
  UpdateFarmerVehicleById,
  UpdateFarmerIncomeById,
  SaveCargillsConnectDetails,
  GetCargillsConnectDetails,
  DeleteCargillsConnectDetails,
  GetFarmerFestivalByFarmerID,
  GetAllFarmingMasterDetails,
  GetAllFarmingChildDetailsByFarmingMasterID,
  GetAllFestivalDetails,
  ApproveFarmer,
  GetAllOwnershipOfFarmingLandTypes,
  GetOwnershipOfFarmingLandByFarmerID,
  GetAllFarmerLanguageTypes,
  GetDsDivisionsForDropdown,
  GetGnDivisionsForDropdown,
  GetFarmerLanguageByFarmerID,
  SaveFarmerSupplierProduceDetail,
  UpdateFarmerSupplierProduceDetail,
  GetFarmerSupplierProduceByFarmerID,
  DeleteFarmerSupplierProduceDetail,
  GetFarmerContactPersonByFarmerID,
  UpdateFarmerContactPersonDetail,
  SaveFarmerContactPersonDetail,
  DeleteFarmerContactDetails,
  SaveFarmerBusinessDetail,
  UpdateFarmerBusinessDetail,
  DeleteFarmerBusinessDetail,
  GetFarmerFarmerBusinessDetailByFarmerID,
  GetAllBusinessDetailsbyFarmerID,
  CheckFarmerDocumentAvailability,
  GetAllFarmerDocumentType,
  SaveFarmerRejectHistory,
  GetSupplierTypeIDbyFarmerID,
  GetModeofOperationbyFarmerID,
  CheckIfScholarshipExists,
  SaveFarmerCertificationDetail,
  DeleteFarmerCertificationDetail,
  GetFarmerCertificationByFarmerID,
  GetProductCategotiesForDropDown,
  GetProductsByFactoryIDProductcatogeryID,
  GetAllFarmerCertificationType,
  GetCollectionCenterByFarmerID,
  GetCollectionCenterByFarmerCollectionCenterID
};

async function GetProductCategoties() {
  const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
  return response.data;
}

async function GetProductTypes() {
  const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
  return response.data;
}

async function GetProductDetails(productcatogeryID) {
  const response = await CommonGet(
    '/api/Product/GetAllProducts',
    'productcatogeryID=' + parseInt(productcatogeryID)
  );
  return response.data;
}

async function GetProductDetailsByProductID(productID) {
  const response = await CommonGet('/api/Product/getProductDetailsByID', 'productID=' + productID);
  return response.data;
}

async function SaveProduct(values, image) {
  var formdata = {
    ProductCode: values.productCode,
    ProductName: values.productName,
    ProductDescription: values.productDescription,
    ProductCategoryID: parseInt(values.productCategoryID),
    ProductTypeID: parseInt(values.productTypeID),
    IsActive: values.isActive,
    CreatedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    CreatedDate: new Date(),
    Image: image
  };

  const response = await CommonPost('/api/Product/SaveProduct', null, formdata);
  return response;
}

async function UpdateProduct(values, productID) {
  var formdata = {
    ProductID: parseInt(productID),
    ProductCode: values.productCode,
    ProductName: values.productName,
    ProductDescription: values.productDescription,
    ProductCategoryID: parseInt(values.productCategoryID),
    ProductTypeID: parseInt(values.productTypeID),
    Image: values.image,
    IsActive: values.isActive,
    ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    ModifiedDate: new Date()
  };

  const response = await CommonPost('/api/Product/UpdateProduct', null, formdata);
  return response;
}

async function SaveFarmer(farmerModel, DocumentData, farmerFestival, ownershipOfFarmingLand, language, otherFestival) {
  var formData = {
    groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
    collectionCenterID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
    givenName: farmerModel.givenName,
    firstName: farmerModel.firstName,
    middleName: farmerModel.middleName,
    lastName: farmerModel.lastName,
    nic: farmerModel.nic,
    joingDate: farmerModel.joiningDate,
    gender: parseInt(farmerModel.gender),
    registrationNumber: farmerModel.regNumber,
    navisionNumber: farmerModel.navisionNumber,
    province: parseInt(farmerModel.province),
    district: parseInt(farmerModel.district),
    city: parseInt(farmerModel.city),
    address1: farmerModel.address1,
    address2: farmerModel.address2,
    address3: farmerModel.address3,
    mobileNumber: parseInt(farmerModel.farmerMobile),
    landNumber: farmerModel.landMobile == "" ? 0 : parseInt(farmerModel.landMobile),
    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    distance: farmerModel.distance,
    dob: farmerModel.dob,
    nationality: farmerModel.nationality,
    maritalStatus: farmerModel.maritalStatus,
    education: isNaN(parseInt(farmerModel.education).toString()) ? "0" : parseInt(farmerModel.education).toString(),
    email: farmerModel.email,
    isActive: Boolean(farmerModel.isActive),
    farmerTypeID: parseInt(farmerModel.farmerTypeID),
    secondaryMobile: farmerModel.secondaryMobile == "" ? 0 : parseInt(farmerModel.secondaryMobile),
    numberofChildren: parseInt(farmerModel.numberofChildren),
    repayingaloan: parseInt(farmerModel.repayingaloan),
    sarubimareception: parseInt(farmerModel.sarubimareception),
    extentID: parseInt(farmerModel.extentID),
    extentValue: farmerModel.extentValue == "" ? 0 : parseFloat(farmerModel.extentValue),
    ownershipOfFarmingLandID: parseInt(farmerModel.ownershipOfFarmingLandID),
    seasonalFarmer: parseInt(farmerModel.seasonalFarmer),
    acknowledgementOne: farmerModel.acknowledgement == false ? false : Boolean(farmerModel.acknowledgementOne),
    acknowledgementTwo: farmerModel.acknowledgement == false ? false : Boolean(farmerModel.acknowledgementTwo),
    FarmerDocumentSaveModels: DocumentData,
    festival: farmerFestival,
    ownershipOfFarmingLand: ownershipOfFarmingLand,
    language: language,
    modeOfOperation: parseInt(farmerModel.modeOfOperation),
    titleID: parseInt(farmerModel.titleID),
    otherTitle: parseInt(farmerModel.titleID) == 5 ? farmerModel.otherTitle : "",
    businessName: parseInt(farmerModel.modeOfOperation) == 1 ? farmerModel.businessName : "",
    brNumber: parseInt(farmerModel.modeOfOperation) == 1 ? farmerModel.nic : "",
    otherEducation: parseInt(farmerModel.education) == 10 ? farmerModel.otherEducation : "",
    dsDivisionID: parseInt(farmerModel.dsDivisionID),
    gnDivisionID: parseInt(farmerModel.gnDivisionID),
    otherFestivalsCelebrated: otherFestival == true ? farmerModel.otherFestivalsCelebrated : "",
    isDormant: Boolean(farmerModel.isDormant),
  }
  const response = await CommonPost('/api/Farmer/SaveFarmer', null, formData);
  return response;
}

async function GetProvinceForDropdown() {
  const response = await CommonGet('/api/Province/GetAllProvince', null);
  return response.data;
}

async function GetDistrictForDropdown(provinceID) {
  const response = await CommonGet(
    '/api/District/GetAllDistrictByProvinceID',
    'provinceID=' + parseInt(provinceID)
  );
  return response.data;
}

async function GetCityForDropdown(provinceID, districtID) {
  const response = await CommonGet(
    '/api/City/GetCityByProvinceIDDistrictID',
    'provinceID=' + parseInt(provinceID) + '&' + 'districtID=' + parseInt(districtID)
  );
  return response.data;
}

async function GetDsDivisionsForDropdown(model) {
  const response = await CommonPost(
    '/api/City/GetDsDivisionsForDropdown', null, model);
  return response.data;
}

async function GetGnDivisionsForDropdown(model) {
  const response = await CommonPost(
    '/api/City/GetGnDivisionsForDropdown', null, model);
  return response.data;
}

async function GetAllFarmers() {
  const response = await CommonGet('/api/Farmer/GetAllFarmers', null);
  return response;
}

async function GetFarmerByFarmerID(farmerID) {
  const response = await CommonGet('/api/Farmer/GetFarmerDetailsCombinedByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function GetFarmerFestivalByFarmerID(farmerID) {
  const response = await CommonGet('/api/Farmer/GetFarmerFestivalByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function GetFarmerLanguageByFarmerID(farmerID) {
  const response = await CommonGet('/api/Farmer/GetFarmerLanguageByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function GetOwnershipOfFarmingLandByFarmerID(farmerID) {
  const response = await CommonGet('/api/OwnershipOfFarmingLand/GetFarmerOwnershipOfFarmingLandByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function GetRouteByFactoryID(factoryID) {
  const response = await CommonGet(
    '/api/Group/GetRouteByFactoryID',
    'factoryID=' + parseInt(factoryID)
  );
  return response.data;
}

async function GetFarmeCroprByFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/Farmer/GetFarmerCropByFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response;
}

async function UpdateFarmer(farmerModel, farmerID, farmerFestival, ownershipOfFarmingLand, language, otherFestival) {
  var formData = {
    farmerID: parseInt(farmerID),
    groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
    collectionCenterID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
    givenName: farmerModel.givenName,
    firstName: farmerModel.firstName,
    middleName: farmerModel.middleName,
    lastName: farmerModel.lastName,
    nic: farmerModel.nic,
    joingDate: farmerModel.joiningDate,
    gender: parseInt(farmerModel.gender),
    registrationNumber: farmerModel.regNumber,
    navisionNumber: farmerModel.navisionNumber,
    province: parseInt(farmerModel.province),
    district: parseInt(farmerModel.district),
    city: parseInt(farmerModel.city),
    address1: farmerModel.address1,
    address2: farmerModel.address2,
    address3: farmerModel.address3,
    mobileNumber: parseInt(farmerModel.farmerMobile),
    landNumber: farmerModel.landMobile == "" ? 0 : parseInt(farmerModel.landMobile),
    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    distance: farmerModel.distance,
    dob: farmerModel.dob,
    nationality: parseInt(farmerModel.nationality),
    maritalStatus: farmerModel.maritalStatus,
    education: parseInt(farmerModel.education).toString(),
    email: farmerModel.email,
    isActive: Boolean(farmerModel.isActive),
    farmerTypeID: parseInt(farmerModel.farmerTypeID),
    secondaryMobile: farmerModel.secondaryMobile == "" ? 0 : parseInt(farmerModel.secondaryMobile),
    numberofChildren: parseInt(farmerModel.numberofChildren),
    repayingaloan: parseInt(farmerModel.repayingaloan),
    sarubimareception: parseInt(farmerModel.sarubimareception),
    extentID: parseInt(farmerModel.extentID),
    extentValue: farmerModel.extentValue == "" ? 0 : parseFloat(farmerModel.extentValue),
    ownershipOfFarmingLandID: parseInt(farmerModel.ownershipOfFarmingLandID),
    seasonalFarmer: parseInt(farmerModel.seasonalFarmer),
    acknowledgementOne: farmerModel.acknowledgement == false ? false : Boolean(farmerModel.acknowledgementOne),
    acknowledgementTwo: farmerModel.acknowledgement == false ? false : Boolean(farmerModel.acknowledgementTwo),
    festival: farmerFestival,
    ownershipOfFarmingLand: ownershipOfFarmingLand,
    language: language,
    modeOfOperation: parseInt(farmerModel.modeOfOperation),
    titleID: parseInt(farmerModel.titleID),
    otherTitle: parseInt(farmerModel.titleID) == 5 ? farmerModel.otherTitle : "",
    businessName: parseInt(farmerModel.modeOfOperation) == 1 ? farmerModel.businessName : "",
    brNumber: parseInt(farmerModel.modeOfOperation) == 1 ? farmerModel.nic : "",
    otherEducation: parseInt(farmerModel.education) == 10 ? farmerModel.otherEducation : "",
    dsDivisionID: parseInt(farmerModel.dsDivisionID),
    gnDivisionID: parseInt(farmerModel.gnDivisionID),
    otherFestivalsCelebrated: otherFestival == true ? farmerModel.otherFestivalsCelebrated : "",
    isDormant: Boolean(farmerModel.isDormant),
  }
  const response = await CommonPost('/api/Farmer/UpdateFarmer', null, formData);
  return response;
}

async function DeleteFarmerCrop(farmerID, farmerCropMappingID, modifiedBy) {
  const response = await CommonGet(
    '/api/Farmer/UpdateFarmerCropDetails',
    'farmerID=' +
    parseInt(farmerID) +
    '&' +
    'farmerCropMappingID=' +
    parseInt(farmerCropMappingID) +
    '&' +
    'modifiedBy=' +
    1
  );
  return response;
}

async function GetAllGroupsForDropDown() {
  const response = await CommonGet('/api/Group/GetAllGroups', null);
  return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
  const response = await CommonGet(
    '/api/Factory/GetAllFactoriesByGroupID',
    'groupID=' + parseInt(groupID)
  );
  return response.data;
}

async function GetProductLifeCyclePikingDetailsByProductID(productID) {
  const response = await CommonGet(
    '/api/ProductLifeCycle/GetProductLifeCyclePikingDetailsByProductID',
    'productID=' + parseInt(productID)
  );
  return response.data;
}

async function GetRouteByGroupID(groupID) {
  const response = await CommonGet(
    '/api/Group/GetFactoryByGroupID',
    'groupID=' + parseInt(groupID)
  );
  return response.data;
}

async function GetFarmerCollectionCenterDetailsByFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/Farmer/GetFarmerCollectionCenterDetailsByFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response;
}

async function DeleteFarmerCollectionCenterDetails(
  farmerID,
  farmerCollectionCenterMappingID,
  modifiedBy
) {
  const response = await CommonGet(
    '/api/Farmer/DeleterFarmerCollectonCenterDetails',
    'farmerID=' +
    parseInt(farmerID) +
    '&' +
    'farmerCollectionCenterMappingID=' +
    parseInt(farmerCollectionCenterMappingID) +
    '&' +
    'modifiedBy=' +
    modifiedBy
  );
  return response;
}

async function GetFarmersByGroupIDAndOperationEntityID(values) {
  const response = await CommonGet(
    '/api/Farmer/GetFarmersByGroupIDAndOperationEntityID',
    'groupID=' +
    parseInt(values.groupID) +
    '&' +
    'operationEntityID=' +
    parseInt(values.operationEntityID) + '&isActive=' + parseInt(values.isActive) +
    '&farmerTypeID=' + parseInt(values.farmerTypeID)
  );
  return response;
}

async function GetFarmerDetailsByNIC(nic) {
  const response = await CommonGet('/api/Farmer/GetFarmerDetailsByNIC', 'nic=' + nic);
  return response.data;
}

async function AssignFarmer(farmerModel, farmerID) {
  var formData = {
    farmerID: parseInt(farmerID),
    collectionCenterID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
    createdBy: parseInt(TokenDecoder.getUserIDFromToken())
  };

  const response = await CommonPost('/api/Farmer/AssignFarmer', null, formData);
  return response;
}

async function GetBanksForDropdown() {
  const response = await CommonGet('/api/Bank/GetAllActiveBanks', null);
  return response.data;
}

async function GetBranchForDropdown(bankID) {
  const response = await CommonGet('/api/Branch/GetBranchesByBankID', 'bankID=' + parseInt(bankID));
  return response.data;
}

async function SaveFarmerBankDetails(model, farmerID, isDefault) {
  var formData = {
    farmerId: parseInt(farmerID),
    bankID: parseInt(model.bankID),
    branchCode: model.branchCode,
    accountnumber: model.accountnumber,
    accountName: model.accountName,
    branchID: parseInt(model.branchID),
    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    isDefault: isDefault,
    image: model.image
  }
  const response = await CommonPost('/api/Bank/SaveFarmerBankDetails', null, formData);
  return response.data;
}

async function GetBankDetailsbyFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/Bank/GetAllBankAccountDetailsbyFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function DeleteFarmerBankDetails(farmerBankDetailsID) {
  const response = await CommonPost(
    '/api/Bank/DeleteBankDetails',
    'farmerBankDetailsID=' +
    parseInt(farmerBankDetailsID) +
    '&' +
    'modifiedBy=' +
    parseInt(TokenDecoder.getUserIDFromToken())
  );
  return response.data;
}
async function GetLoanTypeDetails() {
  const response = await CommonGet('/api/Loan/GetLoanTypeDetails', null);
  return response.data;
}

async function SaveFarmerLoanDetails(model) {
  const response = await CommonPost('/api/Loan/SaveFarmerLoanDetails', null, model);
  return response.data;
}

async function UpdateFarmerLoanDetails(saveModel) {
  const response = await CommonPost('/api/Farmer/UpdateFarmerLoanDetails', null, saveModel);
  return response;
}

async function GetAllLoanDetailsbyFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/Loan/GetAllLoanDetailsbyFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function DeleteLoanDetails(farmerLoanDetailID) {
  const response = await CommonPost(
    '/api/Loan/DeleteLoanDetails',
    'farmerLoanDetailID=' +
    parseInt(farmerLoanDetailID) +
    '&' +
    'modifiedBy=' +
    parseInt(TokenDecoder.getUserIDFromToken())
  );
  return response.data;
}

async function SaveFarmerScholarshipDetails(model) {
  const response = await CommonPost(
    '/api/FarmerScholarship/SaveFarmerScholarshipDetails',
    null,
    model
  );
  return response.data;
}

async function UpdateFarmerScholarshipDetails(model) {
  const response = await CommonPost(
    '/api/FarmerScholarship/UpdateFarmerScholarshipDetails',
    null,
    model
  );
  return response;
}

async function GetFarmerScholarshipDetailsbyFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/FarmerScholarship/GetFarmerScholarshipDetailsbyFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function GetFarmerFamilyDetailsbyFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/FarmerScholarship/GetFarmerFamilyDetailsbyFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function DeleteScholarshipDetails(farmerScholarshipDetailID) {
  const response = await CommonPost(
    '/api/FarmerScholarship/DeleteScholarshipDetails',
    'farmerScholarshipDetailID=' +
    parseInt(farmerScholarshipDetailID) +
    '&' +
    'modifiedBy=' +
    parseInt(TokenDecoder.getUserIDFromToken())
  );
  return response.data;
}

async function SaveFarmerFamilyDetail(model) {
  const response = await CommonPost('/api/Farmer/SaveFarmerFamilyDetail', null, model);
  return response;
}

async function UpdateFarmerFamilyDetail(model) {
  const response = await CommonPost('/api/Farmer/UpdateFarmerFamilyDetail', null, model);
  return response;
}

async function DeleteFarmerFamilyDetil(farmerFamilyDetailID) {
  const response = await CommonGet(
    '/api/Farmer/DeleteFarmerFamilyDetil',
    'farmerFamilyDetailID=' + farmerFamilyDetailID
  );
  return response;
}

async function GetFarmerFamilyByFarmerID(farmerID) {
  const response = await CommonGet('/api/Farmer/GetFarmerFamilyByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function SaveFarmingDetails(model) {
  const response = await CommonPost('/api/Farming/SaveFarmingDetails', null, model);
  return response.data;
}

async function UpdateFarmingDetails(model) {
  const response = await CommonPost('/api/Farming/UpdateFarmingDetails', null, model);
  return response;
}

async function GetFarmingDetailsbyFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/Farming/GetFarmingDetailsbyFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function DeleteFarmingDetails(farmerFarmingDetailID) {
  const response = await CommonPost(
    '/api/Farming/DeleteFarmingDetails',
    'farmerFarmingDetailID=' +
    parseInt(farmerFarmingDetailID) +
    '&' +
    'modifiedBy=' +
    parseInt(TokenDecoder.getUserIDFromToken())
  );
  return response.data;
}

async function UpdateFarmerBankDetails(model) {
  const response = await CommonPost('/api/Bank/UpdateFarmerBankDetails', null, model);
  return response;
}

async function GetAllFarmerDocumentByFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/Farmer/GetAllFarmerDocumentByFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function DeleteFarmerDocument(FarmerDocumentID) {
  let model = {
    farmerDocumentID: FarmerDocumentID,
    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    modifiedDate: new Date().toISOString()
  };
  const response = await CommonPost('/api/Farmer/RemoveFarmerDocument', null, model);
  return response;
}

async function SaveFarmerDocumentInUpdate(model) {
  const response = await CommonPost('/api/Farmer/SaveFarmerDocumentInUpdate', null, model);
  return response;
}

async function SaveVehicleData(formdata) {
  const response = await CommonPost('/api/FarmerIncomeAsset/SaveFarmerVehicleDetails', null, formdata);
  return response;
}

async function SaveIncomeData(incomeData) {
  const response = await CommonPost('/api/FarmerIncomeAsset/SaveFarmerIncomeDetails', null, incomeData);
  return response;
}

async function GetIncomeandVehicleData(farmerID) {
  const response = await CommonGet('/api/FarmerIncomeAsset/GetFarmerIncomeAndVehicleDetails', 'farmerID=' + parseInt(farmerID));
  return response.data;
}

async function DeleteFarmerIncomeDetails(farmerIncomeID) {
  let incomeModel = {
    farmerIncomeID: farmerIncomeID,
    createdBy: parseInt(TokenDecoder.getUserIDFromToken())
  };
  const response = await CommonPost('/api/FarmerIncomeAsset/DeleteFarmerIncomeDetails',
    null, incomeModel
  );
  return response;
}

async function DeleteFarmerVehicleDetails(farmerVehicleID) {
  let vehicleModel = {
    farmerVehicleID: farmerVehicleID,
    createdBy: parseInt(TokenDecoder.getUserIDFromToken())
  }
  const response = await CommonPost('/api/FarmerIncomeAsset/DeleteFarmerVehicleDetails',
    null, vehicleModel);
  return response;
}


async function UpdateFarmerVehicleById(vehicleData) {
  const response = await CommonPost('/api/FarmerIncomeAsset/UpdateFarmerVehicleById', null, vehicleData);
  return response;
}

async function UpdateFarmerIncomeById(incomeData) {
  const response = await CommonPost('/api/FarmerIncomeAsset/UpdateFarmerIncomeById', null, incomeData);
  return response;
}

async function SaveCargillsConnectDetails(model) {
  const response = await CommonPost('/api/CargillsConnect/SaveCargillsConnectDeatils', null, model);
  return response;
}

async function GetCargillsConnectDetails(farmerID) {
  const response = await CommonGet('/api/CargillsConnect/GetCargillsConnectDeatilsbyFarmerID', 'farmerID=' + parseInt(farmerID));
  return response.data;
}

async function DeleteCargillsConnectDetails(cargillsConnectID) {
  let model = {
    cargillsConnectID: cargillsConnectID,
    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
  }
  const response = await CommonPost('/api/CargillsConnect/DeleteCargillsConnectDeatils', null, model);
  return response;
}

async function GetAllFarmingMasterDetails() {
  const response = await CommonGet('/api/Farming/GetAllFarmingMasterDetails', null);
  return response.data;
}

async function GetAllFarmingChildDetailsByFarmingMasterID(farmingMasterID) {
  const response = await CommonGet('/api/Farming/GetAllFarmingChildDetailsByFarmingMasterID', 'farmingMasterID=' + parseInt(farmingMasterID));
  return response.data;
}

async function GetAllFestivalDetails() {
  const response = await CommonGet('/api/Farmer/GetAllFestivalTypes', null);
  return response.data;
}

async function GetAllFarmerLanguageTypes() {
  const response = await CommonGet('/api/Farmer/GetAllFarmerLanguageTypes', null);
  return response.data;
}

async function GetAllOwnershipOfFarmingLandTypes() {
  const response = await CommonGet('/api/OwnershipOfFarmingLand/GetAllOwnershipOfFarmingLandTypes', null);
  return response.data;
}

async function ApproveFarmer(farmerID, farmerStatus, farmerCode, givenName, collectionCenterID, navisionNumber) {
  let model = {
    farmerID: parseInt(farmerID),
    farmerStatus: parseInt(farmerStatus),
    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    farmerCode: farmerCode,
    givenName: givenName,
    collectionCenterID: parseInt(collectionCenterID),
    navisionNumber: navisionNumber
  }
  const response = await CommonPost('/api/Farmer/SaveFarmerApprovalHistory', null, model);
  return response;
}


async function SaveFarmerSupplierProduceDetail(model) {
  const response = await CommonPost('/api/SupplierProduce/SaveFarmerSupplierProduceDetail', null, model);
  return response;
}

async function UpdateFarmerSupplierProduceDetail(model) {
  const response = await CommonPost('/api/SupplierProduce/SaveFarmerSupplierProduceDetail', null, model);
  return response;
}

async function DeleteFarmerSupplierProduceDetail(farmerSupplierProduceID) {
  let model = {
    farmerSupplierProduceID: farmerSupplierProduceID,
    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
  }
  const response = await CommonPost('/api/SupplierProduce/DeleteFarmerSupplierProduceDetail', null, model);
  return response;
}

async function GetFarmerSupplierProduceByFarmerID(farmerID) {
  const response = await CommonGet('/api/SupplierProduce/GetFarmerSupplierProduceByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function SaveFarmerContactPersonDetail(model) {
  const response = await CommonPost('/api/ContactPerson/SaveFarmerContactPersonDetail', null, model);
  return response;
}

async function UpdateFarmerContactPersonDetail(model) {
  const response = await CommonPost('/api/ContactPerson/SaveFarmerContactPersonDetail', null, model);
  return response;
}

async function DeleteFarmerContactDetails(farmerContactPersonID) {
  let model = {
    farmerContactPersonID: farmerContactPersonID,
    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
  }
  const response = await CommonPost('/api/ContactPerson/DeleteFarmerContactDetails', null, model);
  return response;
}

async function GetFarmerContactPersonByFarmerID(farmerID) {
  const response = await CommonGet('/api/ContactPerson/GetFarmerContactPersonByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function SaveFarmerBusinessDetail(model) {
  const response = await CommonPost('/api/FarmerBusiness/SaveFarmerBusinessDetail', null, model);
  return response;
}

async function UpdateFarmerBusinessDetail(model) {
  const response = await CommonPost('/api/FarmerBusiness/SaveFarmerBusinessDetail', null, model);
  return response;
}

async function DeleteFarmerBusinessDetail(farmerBusinessDetailsID) {
  let model = {
    farmerBusinessDetailsID: farmerBusinessDetailsID,
    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
  }
  const response = await CommonPost('/api/FarmerBusiness/DeleteBusinessDetails', null, model);
  return response;
}

async function GetFarmerFarmerBusinessDetailByFarmerID(farmerID) {
  const response = await CommonGet('/api/FarmerBusiness/GetFarmerFarmerBusinessDetailByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function GetAllBusinessDetailsbyFarmerID(farmerID) {
  const response = await CommonGet(
    '/api/FarmerBusiness/GetAllBusinessDetailsbyFarmerID',
    'farmerID=' + parseInt(farmerID)
  );
  return response.data;
}

async function CheckFarmerDocumentAvailability(farmerID) {
  const response = await CommonGet('/api/Farmer/CheckFarmerDocumentAvailability', 'farmerID=' + parseInt(farmerID));
  return response.data;
}

async function GetAllFarmerDocumentType() {
  const response = await CommonGet('/api/FarmerDocument/GetAllFarmerDocumentType', null);
  return response.data;
}

async function SaveFarmerRejectHistory(model) {
  const response = await CommonPost('/api/Farmer/SaveFarmerRejectHistory', null, model);
  return response;
}

async function GetSupplierTypeIDbyFarmerID(farmerID) {
  const response = await CommonGet('/api/Farmer/GetSupplierTypeIDbyFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}


async function GetModeofOperationbyFarmerID(farmerID) {
  const response = await CommonGet('/api/Farmer/GetModeofOperationbyFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function CheckIfScholarshipExists(farmerFamilyDetailID) {
  const response = await CommonGet(
    '/api/Farmer/CheckIfScholarshipExists',
    'farmerFamilyDetailID=' + farmerFamilyDetailID
  );
  return response;
}

async function SaveFarmerCertificationDetail(model) {
  const response = await CommonPost('/api/FarmerCertification/SaveFarmerCertificationDetail', null, model);
  return response;
}

async function DeleteFarmerCertificationDetail(farmerCertificationID) {
  let model = {
    farmerCertificationID: farmerCertificationID,
    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
  }
  const response = await CommonPost('/api/FarmerCertification/DeleteFarmerCertificationDetail', null, model);
  return response;
}

async function GetFarmerCertificationByFarmerID(farmerID) {
  const response = await CommonGet('/api/FarmerCertification/GetFarmerCertificationByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response;
}

async function GetProductCategotiesForDropDown() {
  const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetailsForDropDown', null);
  return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
  const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
  return response.data;
}

async function GetAllFarmerCertificationType() {
  const response = await CommonGet('/api/FarmerCertification/GetAllFarmerCertificationType', null);
  return response.data;
}

async function GetCollectionCenterByFarmerID(farmerID) {
  const response = await CommonGet('/api/FarmerCertification/GetCollectionCenterByFarmerID', 'farmerID=' + parseInt(farmerID));
  return response.data;
}

async function GetCollectionCenterByFarmerCollectionCenterID(farmerCollectionCenterID, farmerID) {
  const response = await CommonGet('/api/FarmerCertification/GetCollectionCenterByFarmerCollectionCenterID', 'farmerCollectionCenterID=' + parseInt(farmerCollectionCenterID) + '&farmerID=' + parseInt(farmerID));
  return response.data;
}